import React from 'react'

const StatusLabelBusiness = (props) => {
  let badge
  const { state } = props
  switch (state) {
    case 'accepted':
      badge = <span className='label label-success text-uppercase'>{state}</span>
      break
    case 'hold':
      badge = <span className='label text-uppercase'>{state}</span>
      break
    case 'open':
      badge = (
        <span style={{ backgroundColor: '#808080', color: 'white' }} className='label label-information text-uppercase'>
          {state}
        </span>
      )
      break
    case 'rejected':
      badge = <span className='label label-danger text-uppercase'>{state}</span>
      break
    default:
  }
  return badge
}

export default StatusLabelBusiness
